










































































































import { Component, Vue } from 'vue-property-decorator';

import BaseFooter from '@/components/base/Footer.vue';
import BaseHeader from '@/components/base/Header.vue';
import Sidebar from '@/components/Sidebar.vue';
import { sessionStore } from '@/store/session';

@Component({
  components: {
    Sidebar,
    BaseFooter,
    BaseHeader,
  },
})
export default class App extends Vue {
  private toggleSidebar() {
    (this.$refs.sidebar as Sidebar).toggleSidebar();
  }

  get isLoggedIn(): boolean {
    return sessionStore.session?.user?.authenticated;
  }
}
